<script setup>
import SiteConfig from '@/services/SiteConfig.js'
import { computed, nextTick, watch } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})

const orderNr = computed(() => props.data.orderNr)
const amount = computed(() => props.data.amount)
const currency = computed(() => props.data.currency)
const paymentType = computed(() => props.data.paymentType)
const email = computed(() => props.data.email)
const estDeliveryDate = computed(() => props.data.estDeliveryDate)

const siteIdToTsIdMap = {
  de: import.meta.env.VITE_TRUSTED_SHOPS_ID_VIC_DE,
  at: import.meta.env.VITE_TRUSTED_SHOPS_ID_VIC_AT,
  ch: import.meta.env.VITE_TRUSTED_SHOPS_ID_VIC_CH
}
const locale = SiteConfig.locale
const TS_ID = siteIdToTsIdMap[locale]

function injectTrustedShopsScript() {
  if (typeof window === 'undefined') return

  // Remove old script if present
  const oldScript = document.getElementById('ts-trustcard-script')
  if (oldScript) oldScript.remove()

  if (!TS_ID) return

  window._tsConfig = {
    customCheckoutElementId: 'trustbadgeCustomCheckoutContainer',
    trustCardTrigger: 'mouseenter',
    variant: 'reviews',
    disableTrustbadge: false,
    disableResponsive: false,
    yOffset: '0'
  }

  const script = document.createElement('script')
  script.id = 'ts-trustcard-script'
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://widgets.trustedshops.com/js/${TS_ID}.js`
  document.body.appendChild(script)
}

// Watch for when required order data is set, then inject the script
// Only require orderNr, amount, and currency (paymentType is optional)
watch(
  () => [orderNr.value, amount.value, currency.value],
  async (vals) => {
    if (vals.every(Boolean)) {
      await nextTick()
      injectTrustedShopsScript()
    }
  },
  { immediate: true }
)
</script>

<template>
  <div id="trustedShopsCheckout" style="display: none">
    <span id="tsCheckoutOrderNr">{{ orderNr }}</span>
    <span id="tsCheckoutBuyerEmail">{{ email }}</span>
    <span id="tsCheckoutOrderAmount">{{ amount }}</span>
    <span id="tsCheckoutOrderCurrency">{{ currency }}</span>
    <span id="tsCheckoutOrderPaymentType">{{ paymentType }}</span>
    <span id="tsCheckoutOrderEstDeliveryDate">{{ estDeliveryDate }}</span>
  </div>
  <div
    class="py-5 d-flex align-center justify-center flex-column w-100"
    id="trustbadgeCustomCheckoutContainer"
  />
</template>
